module.exports = __webpack_public_path__ + "img/book-headauto.ab148780.png";